<template>
  <div class="containerFull">
    <info-card
      style="margin-bottom:20px"
      v-for="(documento, index) in documentos"
      :key="index"
      :titulo="documento.titulo"
      :ultimaActualizacion="documento.updated"
      :resumen="documento.resumen"
      :linkFile="documento.archivo"
      :linkIcon="documento.icon?urlIcons+documento.icon:'/assets/layout/images/info.png'"
    />
  </div>
</template>
<script>
import info_card from "./info_card.vue";
import InfoService from "../service/informacion.service";
export default {
  name: "informacion",
  metaInfo: {
    title: 'Información - QualityCare',
    htmlAttrs: {
      lang: 'es',
    },
    meta: [
      {
        name: 'Información - QualityCare',
        content: 'Se muestra información relevante para el usuario',
      },
    ],
  },
  components: { "info-card": info_card },
  data() {
    return {
      infoService: null,
      documentos: [],
      urlIcons: process.env.VUE_APP_API_AVATAR
    };
  },
  created() {
    this.infoService = new InfoService();
  },
  mounted() {
    this.infoService
      .allDocuments()
      .then((result) => {
        this.documentos = [...result.data.data];
      })
      .catch((err) => {
        console.error(err);
      });
  },
};
</script>

<style lang="scss" scoped>
.containerFull {  
  min-height: 600px;  
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  padding: 20px 300px;
}
@media screen and (max-width: 1200px) {
  .containerFull{
    padding: 20px 40px;
  }
}
@media screen and (max-width: 800px) {  
  .containerFull{
    padding: 10px 10px;
  }
}
</style>
